import { Link } from "react-router-dom";
import { Select } from "../../components/ui/Input";
import { LabelWithHint } from "../../components/ui/Tooltip";
import { useExperiments } from "../experiments/useExperiments";

const GROUP_HELP =
	"Show this campaign only to shoppers Intelligems puts in one group. Its discount is enforced at checkout too, so other groups cannot redeem it. Whether shoppers outside the test see it is set on the test, under A/B tests.";

type ExperimentGroupFieldProps = {
	value: string | null;
	onChange: (experimentGroupId: string | null) => void;
};

export const ExperimentGroupField = ({ value, onChange }: ExperimentGroupFieldProps) => {
	const experiments = useExperiments();
	const items = experiments.data?.items ?? [];

	return (
		<div className="max-w-md space-y-1.5">
			<LabelWithHint label="A/B test group">{GROUP_HELP}</LabelWithHint>
			<Select
				value={value ?? ""}
				onChange={(event) => onChange(event.target.value || null)}
				disabled={experiments.isPending}
			>
				<option value="">Every shopper</option>
				{items.map((experiment) => (
					<optgroup key={experiment.id} label={experiment.title}>
						{experiment.groups.map((group) => (
							<option key={group.id} value={group.id}>
								{group.isFallback ? `${group.name} (and shoppers outside the test)` : group.name}
							</option>
						))}
					</optgroup>
				))}
			</Select>
			{experiments.data && items.length === 0 ? (
				<p className="text-xs text-ink-muted">
					To test this campaign against another,{" "}
					<Link to="/experiments" className="text-ink underline underline-offset-4">
						connect an Intelligems test
					</Link>{" "}
					first.
				</p>
			) : null}
		</div>
	);
};
